import { app } from '@ibgroup-tws-webapps/ratio.ui';

const FORECASTX_EXCHANGE = 'FORECASTX';

/** AB feature: route FORECASTX closes through the CTCI order ticket. */
const USE_CTCI_ORDER = 'USE_CTCI_ORDER';

/** iOS/Android (incl. globaltrader/impact variants) are the native mobile shells. */
function isMobilePlatform(): boolean {
  const platform = app.option?.clientPlatform ?? '';
  return platform.startsWith('ios') || platform.startsWith('android');
}

/** Web hosts always close against the held contract, never the FORECASTX opposite. */
function isWebPlatform(): boolean {
  return app.option?.clientPlatform === 'web' || app.option?.platform === 'web';
}

/**
 * When the CTCI order ticket AB feature is on and we are on native mobile,
 * FORECASTX positions are closed against the held contract directly rather
 * than by buying the opposite contract.
 */
export function isCtciMobileClose(): boolean {
  return !!app.abFeatures?.hasFeature(USE_CTCI_ORDER) && isMobilePlatform();
}

/**
 * Resolves which conid to send when closing a position.
 *
 * Historically FORECASTX closes by BUYING the opposite contract (`forecastxConid`),
 * while every other venue closes against the held contract (`defaultConid`).
 * The FORECASTX flip is suppressed — so we close against the held contract — on
 * web (always) and under the CTCI-mobile path.
 */
export function resolveCloseConid(params: {
  exchange?: string;
  /** Opposite contract used for the legacy FORECASTX buy-to-close. */
  forecastxConid: number;
  /** Held contract — used by all other venues, on web, and by CTCI-mobile FORECASTX. */
  defaultConid: number;
}): number {
  const useForecastxFlip = params.exchange === FORECASTX_EXCHANGE && !isWebPlatform() && !isCtciMobileClose();
  return useForecastxFlip ? params.forecastxConid : params.defaultConid;
}
